export const toggleButtonGroup = {
    bgcolor: 'info.main',
    borderRadius: 50,
};
export const toggleButton = {
    minWidth: {
        desktop: '171px',
    },
    color: 'primary.main',
    border: 0,
    m: 0.5,
    px: {
        desktop: 5,
        mobile: 4,
    },
    '&:hover': {
        backgroundColor: 'info.main',
        borderRadius: 50,
    },
    '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: 'secondary.dark',
        borderRadius: 50,
    },
    '&.Mui-selected > p, &.Mui-selected:hover > p': {
        color: 'info.light',
    },
    '&.MuiToggleButtonGroup-grouped:not(:last-of-type), &.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
        borderRadius: 50,
    },
};
export default {
    toggleButton,
    toggleButtonGroup,
};
